import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { UnsavedDataHelper } from '../shared/unsaved-data-helper';
import { DirtyComponent } from './dirty-component';

@Injectable({
  providedIn: 'root'
})
export class UnSavedChangesGuard implements CanDeactivate<DirtyComponent> {
  constructor(private helper: UnsavedDataHelper)
  { }
  canDeactivate(component: DirtyComponent): boolean | Observable<boolean> {
    if(component.isDirty()) {
      return this.helper.checkDirtyElements(component.itemsOfDirtyComponent);
    } else {
      return true;
    }
  }
}
